import * as actionTypes from "../actions/actionTypes";

const initialState = {
    aboutMe: null,
    experiences: null,
    blogs: null,
    errorMsgs: {
        aboutMeErrMsg: "",
        experiencesErrMsg: "",
        blogsErrMsg: "",
    },
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_DETAILS_FAILED:
            return {
                ...state,
                [action.error.type.slice(0, -6)]: null,
                errorMsgs: {
                    ...state.errorMsgs,
                    [action.error.type]: action.error.msg,
                },
            };
        case actionTypes.FETCH_ABOUTME:
            return {
                ...state,
                aboutMe: action.aboutMe,
                errorMsgs: {
                    ...state.errorMsgs,
                    aboutMeErrMsg: "",
                },
            };
        case actionTypes.FETCH_EXPERIENCES:
            return {
                ...state,
                experiences: action.experiences,
                errorMsgs: {
                    ...state.errorMsgs,
                    experiencesErrMsg: "",
                },
            };
        case actionTypes.FETCH_BLOGS:
            return {
                ...state,
                blogs: action.blogs,
                errorMsgs: {
                    ...state.errorMsgs,
                    blogsErrMsg: "",
                },
            };
        default:
            return state;
    }
};

export default reducer;
